<button
  class="btn-large whitespace-nowrap lt-md:!hidden"
  gtm="onExport"
  gtmAction="Assistant feedbacks list"
  gtmCategory="Assistant"
  mat-raised-button
  color="primary"
  [class.disabled]="disabled"
  (click)="generateCsv()"
>
  {{ '+ASSISTANT.FEEDBACKS.EXPORT_LIST' | translate }}
  <mat-icon>download</mat-icon>
</button>
<button
  mat-icon-button
  (click)="generateCsv()"
  class="btn-small lt-md:!flex !hidden"
  gtm="onExport"
  gtmAction="Assistant feedbacks list"
  gtmCategory="Assistant"
  color="primary"
  [class.disabled]="disabled"
>
  <mat-icon>download</mat-icon>
</button>
